var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search-24px copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Select-bank",
    transform: "translate(-1083.000000, -222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(235.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-24px-copy-2",
    transform: "translate(848.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9166667,11.6666667 L12.2583333,11.6666667 L12.025,11.4416667 C12.8416667,10.4916667 13.3333333,9.25833333 13.3333333,7.91666667 C13.3333333,4.925 10.9083333,2.5 7.91666667,2.5 C4.925,2.5 2.5,4.925 2.5,7.91666667 C2.5,10.9083333 4.925,13.3333333 7.91666667,13.3333333 C9.25833333,13.3333333 10.4916667,12.8416667 11.4416667,12.025 L11.6666667,12.2583333 L11.6666667,12.9166667 L15.8333333,17.075 L17.075,15.8333333 L12.9166667,11.6666667 Z M7.91666667,11.6666667 C5.84166667,11.6666667 4.16666667,9.99166667 4.16666667,7.91666667 C4.16666667,5.84166667 5.84166667,4.16666667 7.91666667,4.16666667 C9.99166667,4.16666667 11.6666667,5.84166667 11.6666667,7.91666667 C11.6666667,9.99166667 9.99166667,11.6666667 7.91666667,11.6666667 Z",
    id: "Shape",
    fill: "#455065",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.096f55ee.svg";
export { ForwardRef as ReactComponent };